import { Instalment } from 'types/policy';

export const getMonthlyPremium = (installment: Instalment | undefined): number | undefined => {
  if (!installment) return undefined;
  const { instalmentPremium, instalmentStampDuty, instalmentGST, instalmentLevies } = installment;
  return [instalmentPremium, instalmentStampDuty, instalmentGST, instalmentLevies].reduce(
    (acc, val) => acc + Number(val),
    0
  );
};
